import loopback from '@/services/loopback'

const STORAGE_KEY = 'hideBannerAt'
const HIDE_DURATION_MS = 24 * 60 * 60 * 1000
const API_ENDPOINT = '/banner-notifications/active'

export default {
  shouldShowBanner () {
    const closedAt = localStorage.getItem(STORAGE_KEY)
    if (!closedAt) {
      return true
    }

    const now = Date.now()
    const diff = now - Number(closedAt)
    return diff >= HIDE_DURATION_MS
  },

  closeBanner () {
    localStorage.setItem(STORAGE_KEY, Date.now())
  },

  async getActiveNotification () {
    try {
      if (!loopback.hasToken()) {
        return {
          success: false,
          error: 'No token'
        }
      }
      const bannerNotification = await loopback.get(API_ENDPOINT)
      if (bannerNotification.status === 'success') {
        return {
          success: true,
          data: bannerNotification.data
        }
      }
      return {
        success: false
      }
    } catch (err) {
      console.error('Erro ao buscar notificação de banner')
      return {
        success: false,
        error: err
      }
    }
  },

  clearBannerState () {
    localStorage.removeItem(STORAGE_KEY)
  }
}



// WEBPACK FOOTER //
// ./src/services/banner-notification.js